/**
 * Key bindings - maps keyboard codes to input actions.
 * This is client-side only; the server doesn't need to know about key mappings.
 */

import { InputAction } from '@common/input';

/**
 * Map of keyboard event.code values to input actions.
 * Multiple keys can map to the same action (e.g., WASD + Arrow keys).
 */
export const KEY_BINDINGS: Record<string, InputAction> = {
  // Movement - Arrow keys
  ArrowUp: 'up',
  ArrowDown: 'down',
  ArrowLeft: 'left',
  ArrowRight: 'right',

  // Movement - WASD
  KeyW: 'up',
  KeyS: 'down',
  KeyA: 'left',
  KeyD: 'right',

  // Actions
  KeyE: 'interact',
  Space: 'attack',
  ShiftLeft: 'sneak',
  ShiftRight: 'sneak',
};

/**
 * Get the input action for a keyboard code.
 * @param keyCode - The keyboard event.code value
 * @returns The corresponding input action, or undefined if not mapped
 */
export function getActionForKey(keyCode: string): InputAction | undefined {
  return KEY_BINDINGS[keyCode];
}
